import { ProgramConductor } from "src/components";

export const Programs: React.FC = () => {
  return (
    <div className="app-theme2 conductor-page pb-3">
      <ProgramConductor />
    </div>
  );
};
